module.exports = __webpack_public_path__ + "img/cheng_icon.ab199cc0.png";